import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import {
  DashboardOutlined,
  BookOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import MekakDashboard from './MekakDashboard';
import KnowledgeList from './KnowledgeList';
import AISearch from './AISearch';

const { Title, Text } = Typography;

const TAB_KEYS = {
  DASHBOARD: 'dashboard',
  KNOWLEDGE: 'knowledge',
  SEARCH: 'search',
} as const;

interface MekakPageProps {
  defaultTab?: string;
}

const MekakPage: React.FC<MekakPageProps> = ({ defaultTab }) => {
  const [activeKey, setActiveKey] = useState(defaultTab || TAB_KEYS.SEARCH);

  const items = [
    {
      key: TAB_KEYS.SEARCH,
      label: (
        <span className="flex items-center gap-1.5">
          <SearchOutlined />
          AI 搜尋
        </span>
      ),
      children: <AISearch />,
    },
    {
      key: TAB_KEYS.KNOWLEDGE,
      label: (
        <span className="flex items-center gap-1.5">
          <BookOutlined />
          知識管理
        </span>
      ),
      children: <KnowledgeList />,
    },
    {
      key: TAB_KEYS.DASHBOARD,
      label: (
        <span className="flex items-center gap-1.5">
          <DashboardOutlined />
          統計總覽
        </span>
      ),
      children: <MekakDashboard />,
    },
  ];

  return (
    <div className="p-6 min-h-screen bg-gray-50">
      <div className="mb-4">
        <Title level={3} style={{ margin: 0 }}>
          企業知識管理
        </Title>
        <Text type="secondary">
          企業知識管理與智能化 — 用自然語言搜尋公司知識庫
        </Text>
      </div>

      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        items={items}
        size="large"
        destroyInactiveTabPane={false}
        style={{ minHeight: 400 }}
      />
    </div>
  );
};

export default MekakPage;
